<template>
  <v-alert error @input="onClose" :value="true" icon="new_releases">
    <div v-html="text"></div>
    <router-link :to="link" v-if="link && link_text">{{ link_text }}</router-link>
  </v-alert>
</template>

<script>
  export default {
    props: ['text', 'link', 'link_text'],
    methods: {
      onClose () {
        this.$emit('dismissed')
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/shared/Alert.vue